import React, { ForwardedRef, forwardRef } from 'react'
import NextLink, { LinkProps as NextLinkProps } from 'next/link'
import { styled } from '@mui/material/styles'
import EventPropagationBlocker from 'components/EventPropagationBlocker'

// Add support for the sx prop for consistency with the other branches.
const Anchor = styled('a')({})

export interface NextLinkComposedProps
  extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>,
    Omit<NextLinkProps, 'href' | 'as' | 'passHref' | 'onMouseEnter' | 'onClick' | 'onTouchStart'> {
  to: NextLinkProps['href']
}

/**
 * Next.js Link component adapted for integration with MUI
 * This code was copied and adapted from the Next.js MUI v5 example
 */
const NextLinkComposed = (props: NextLinkComposedProps, ref: ForwardedRef<HTMLAnchorElement>) => {
  const {
    to,
    replace,
    scroll,
    shallow,
    prefetch,
    legacyBehavior = true,
    locale,
    ...other
  } = props

  return (
    <EventPropagationBlocker component="span">
      <NextLink
        href={to}
        prefetch={prefetch}
        replace={replace}
        scroll={scroll}
        shallow={shallow}
        passHref
        locale={locale}
        legacyBehavior={legacyBehavior}
      >
        <Anchor ref={ref} {...other} />
      </NextLink>
    </EventPropagationBlocker>
  )
}

export default forwardRef<HTMLAnchorElement, NextLinkComposedProps>(NextLinkComposed)
